import type { ApiClient } from "@/modules/api/apiClient.ts";
import { getResponseData } from "@/modules/api/apiClient.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { queryOptions, type QueryKey } from "@tanstack/react-query";
import type { BillingAccountUsage } from "@warrenio/api-spec/spec.oats.gen";
import { atomFamily } from "jotai-family";

type Response = BillingAccountUsage[];

interface Params {
    billing_account_id: number;
}

function getQueryKey(params?: Params): QueryKey {
    return params == null ? ["payment/usage"] : ["payment/usage", params.billing_account_id];
}

function getQuery(client: ApiClient, params: Params) {
    return queryOptions({
        queryKey: getQueryKey(params),
        queryFn: async ({ signal }): Promise<Response> => {
            const { billing_account_id } = params;
            return getResponseData(
                await client.GET("/payment/usage", {
                    signal,
                    params: { query: { billing_account_id } },
                }),
            );
        },
    });
}

export const baUsageQueryAtom = atomFamily((billing_account_id: number) =>
    atomFromStandardQueryOptions(getQuery, { billing_account_id }),
);
